

export default class {
    constructor($el) {
        this.$title = $el.find('.-vert-pads');
        this.$controlPlay = $el.find('[data-vimeo-play]');
        this.$controlPause = $el.find('[data-vimeo-pause]');
        this.$title.css('transition', 'opacity 1s');
        let iframe = document.querySelector('.vimeo-iframe');
        this.player = new Vimeo.Player(iframe); /* https://github.com/vimeo/player.js */
        console.log(this.$title[0]);
        this.player.on('play', ()=>{
            this.initialOnPlay();
        });
        // this.$controlPlay.click(()=>{
        //     this.play();
        // });
        // this.$controlPause.click(()=>{
        //     this.pause();
        // });
    }
    initialOnPlay() {
        console.log('initialOnPlay', this.$controlPlay[0]);
        this.$title.css('opacity', 0);
        setTimeout(()=>{
            this.$title.remove();
        }, 1200);
        this.$controlPlay.addClass('-grey');
    }
    play() {
        this.player.play().then(() => {
            console.log('play');
            this.$controlPlay.addClass('-grey');
            this.$controlPause.removeClass('-grey');
        }).catch((error) => {
            switch (error.name) {
                case 'PasswordError':
                    // the video is password-protected and the viewer needs to enter the
                    // password first
                    break;

                case 'PrivacyError':
                    // the video is private
                    break;

                default:
                    // some other error occurred
                    break;
            }
        });
    }
    pause() {
        this.player.pause().then(() => {
            console.log('pause');
            this.$controlPause.addClass('-grey');
            this.$controlPlay.removeClass('-grey');
        }).catch((error) => {
            switch (error.name) {
                case 'PasswordError':
                    // the video is password-protected and the viewer needs to enter the
                    // password first
                    break;

                case 'PrivacyError':
                    // the video is private
                    break;

                default:
                    // some other error occurred
                    break;
            }
        });
    }
}

















// WEBPACK FOOTER //
// ./scripts/lib/VimeoBlock.js